import React, { useState, useRef, useEffect } from "react";
import {
  color,
  darkenColor,
  getFirstLetter,
  isMobile,
  nameColor,
} from "../../utils/general";
import {
  CheckBadgeIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";

const RecipientList = (props) => {
  const [isHover, setIsHover] = useState();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen) {
        // Check if the click is on the dropdown trigger
        const isClickOnTrigger =
          dropdownRef.current && dropdownRef.current.contains(event.target);

        // Check if the click is on the dropdown menu
        const isClickOnDropdownMenu = event.target.closest(
          "[data-dropdown-menu]"
        );

        // Check if the click is on the backdrop
        const isClickOnBackdrop = event.target.closest(
          "[data-dropdown-backdrop]"
        );

        // If click is on backdrop or outside both trigger and dropdown menu, close the dropdown
        if (
          isClickOnBackdrop ||
          (!isClickOnTrigger && !isClickOnDropdownMenu)
        ) {
          setIsDropdownOpen(false);
        }
      }
    };

    if (isDropdownOpen) {
      // Add a small delay to prevent immediate closing when opening
      const timeoutId = setTimeout(() => {
        document.addEventListener("mousedown", handleClickOutside);
      }, 100);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isDropdownOpen]);

  const isWidgetExist = (Id) => {
    const signer = props.signerPos.find((x) => x.Id === Id);
    if (!signer || !signer.placeHolder) return false;
    // Check if placeHolder has any actual widgets
    return signer.placeHolder.some(
      (placeholder) => placeholder.pos && placeholder.pos.length > 0
    );
  };

  const getSelectedRecipients = () => {
    return props.signersdata.filter((obj, ind) => props.uniqueId === obj.Id);
  };

  const selectedRecipients = getSelectedRecipients();
  const hasSelection = selectedRecipients.length > 0;

  const calculateDropdownPosition = () => {
    if (dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 4, // Use viewport coordinates for fixed positioning
        left: rect.left,
        width: rect.width,
      });
    }
  };

  const handleDropdownToggle = () => {
    if (!isDropdownOpen) {
      calculateDropdownPosition();
    }
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleRecipientClick = (obj, ind) => {
    props.setIsSelectId(ind);
    props.setUniqueId(obj.Id);
    props.setRoleName(obj.role);
    props.setBlockColor(obj?.blockColor);
    if (props.handleModal) {
      props.handleModal();
    }
    setIsDropdownOpen(false);
  };

  return (
    <div className="relative z-10" ref={dropdownRef}>
      {/* Dropdown Trigger */}
      <div
        className={`${
          props.sendInOrder
            ? props.isMailSend
              ? "pointer-events-none bg-opacity-80"
              : `text-[12px] font-bold `
            : props.isMailSend && "pointer-events-none bg-opacity-80"
        } flex flex-row rounded-lg bg-white text-base-content px-3 py-2 items-center last:mb-0.5 cursor-pointer border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all duration-200`}
        style={
          {
            // background:
            //   hasSelection && selectedRecipients[0]?.blockColor
            //     ? selectedRecipients[0].blockColor
            //     : hasSelection
            //     ? color[
            //         props.signersdata.findIndex(
            //           (obj) => obj.Id === props.uniqueId
            //         ) % color.length
            //       ]
            //     : "transparent",
          }
        }
        onClick={handleDropdownToggle}
      >
        <div className="flex flex-row items-center w-full">
          {hasSelection ? (
            // Show selected recipient
            selectedRecipients.map((obj, ind) => (
              <div key={ind} className="flex items-center w-full">
                <div
                  className="flex w-[28px] h-[28px] rounded-lg items-center justify-center mr-3 flex-shrink-0"
                  style={{
                    background: obj?.blockColor
                      ? darkenColor(obj?.blockColor, 0.4)
                      : nameColor[ind % nameColor.length],
                  }}
                >
                  <span className="text-white uppercase text-center text-[12px]">
                    {isWidgetExist(obj.Id) ? (
                      <i className="fa-light fa-check"></i>
                    ) : (
                      <>
                        {obj.role
                          ? getFirstLetter(obj.role)
                          : getFirstLetter(obj.role)}
                      </>
                    )}
                  </span>
                </div>
                <div
                  className={`${
                    obj.role ? "flex-col" : "flex-row"
                  } flex flex-1`}
                >
                  {obj.name && (
                    <span
                      className={`text-[13px] font-medium min-w-[100px] max-w-[100px] whitespace-nowrap overflow-hidden text-ellipsis ${
                        hasSelection ? "text-gray-900" : "text-gray-900"
                      }`}
                    >
                      {obj.name}
                    </span>
                  )}

                  <span
                    className={`text-[11px] w-[200px] whitespace-nowrap overflow-hidden text-ellipsis ${
                      hasSelection ? "text-gray-500" : "text-gray-500"
                    }`}
                  >
                    {obj.role}
                  </span>
                </div>
              </div>
            ))
          ) : (
            // Show placeholder when no selection
            <div className="flex items-center w-full">
              <div className="flex w-[28px] h-[28px] rounded-lg items-center justify-center mr-3 bg-gray-200">
                <span className="text-gray-500 text-center text-[12px]">
                  <i className="fa-light fa-user"></i>
                </span>
              </div>
              <div className="flex flex-col">
                <span className="text-[13px] font-medium text-gray-500">
                  Select Recipient
                </span>
                <span className="text-[11px] text-gray-400">
                  Choose from available recipients
                </span>
              </div>
            </div>
          )}

          {/* Dropdown Arrow */}
          <div className="ml-auto">
            <ChevronDownIcon
              className={`w-5 h-5 transition-transform ${
                isDropdownOpen ? "rotate-180" : ""
              } ${hasSelection ? "text-base-content" : "text-base-content"}`}
            />
          </div>
        </div>
      </div>
      {/* <div className="text-sm text-gray-500 mt-2 ml-2">
        {selectedRecipients?.[0]?.email}
      </div> */}

      {/* Backdrop */}
      {isDropdownOpen && (
        <div
          data-dropdown-backdrop
          className="fixed inset-0 z-[9998] bg-black bg-opacity-10"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9998,
          }}
        />
      )}

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div
          data-dropdown-menu
          className="fixed z-[9999] bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"
          style={{
            position: "fixed",
            zIndex: 9999,
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            width: `${Math.max(dropdownPosition.width, 220)}px`,
            minWidth: "220px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          {props.signersdata.length > 0 ? (
            props.signersdata.map((obj, ind) => {
              const isSelected = props.uniqueId === obj.Id;
              return (
                <div
                  key={ind}
                  data-tut="recipientArea"
                  onMouseEnter={() => setIsHover(ind)}
                  onMouseLeave={() => setIsHover(null)}
                  className={`${
                    props.sendInOrder
                      ? props.isMailSend
                        ? "pointer-events-none bg-opacity-80"
                        : `text-[12px] font-bold `
                      : props.isMailSend && "pointer-events-none bg-opacity-80"
                  } flex flex-row rounded-lg px-3 py-2 mx-1 items-center cursor-pointer hover:bg-gray-50 transition-all duration-200 ${
                    isSelected ? "bg-blue-50 border border-blue-200" : ""
                  }`}
                  style={{
                    background:
                      (!isMobile && isHover === ind) || isSelected
                        ? obj?.blockColor
                          ? obj?.blockColor
                          : color[ind % color.length]
                        : "transparent",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleRecipientClick(obj, ind);
                  }}
                >
                  <div className="flex flex-row items-center w-full">
                    <div
                      className="flex w-[28px] h-[28px] rounded-lg items-center justify-center mr-3 flex-shrink-0"
                      style={{
                        background: obj?.blockColor
                          ? darkenColor(obj?.blockColor, 0.4)
                          : nameColor[ind % nameColor.length],
                      }}
                    >
                      <span className="text-white uppercase font-bold text-center text-[12px]">
                        {isWidgetExist(obj.Id) ? (
                          <i className="fa-light fa-check"></i>
                        ) : (
                          <>
                            {obj.role
                              ? getFirstLetter(obj.role)
                              : getFirstLetter(obj.role)}
                          </>
                        )}
                      </span>
                    </div>
                    <div
                      className={`${
                        obj.role ? "flex-col" : "flex-row"
                      } flex flex-1`}
                    >
                      <span
                        className={`${
                          (!isMobile && isHover === ind) ||
                          props.isSelectListId === ind ||
                          isSelected
                            ? "text-white"
                            : "text-gray-900"
                        } text-[13px] font-medium w-[100px] whitespace-nowrap overflow-hidden text-ellipsis`}
                      >
                        {obj.role}
                      </span>
                      {obj.name && (
                        <span
                          className={`${
                            (!isMobile && isHover === ind) ||
                            props.isSelectListId === ind ||
                            isSelected
                              ? "text-white"
                              : "text-gray-600"
                          } text-[11px] min-w-[100px] max-w-[150px] whitespace-nowrap overflow-hidden text-ellipsis`}
                        >
                          {obj.name}
                        </span>
                      )}
                    </div>

                    {/* Selection Indicator */}
                    <div className="ml-auto flex items-center gap-2">
                      {isSelected && (
                        <CheckBadgeIcon className="w-5 h-5 text-white" />
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="px-4 py-3 text-center text-gray-500 text-sm">
              No recipients available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RecipientList;
